import { Text } from "@chakra-ui/react";
import { useRef, useEffect, useState } from "react";
import { Tooltip } from "../ui/chakra/tooltip";

interface TruncateTextProps {
  children: string;
  maxWidth?: number;
  tooltip?: boolean;
}

const TruncateText: React.FC<TruncateTextProps> = ({
  children,
  maxWidth,
  tooltip = true,
}) => {
  const maxW = maxWidth ? maxWidth : 120;
  const textRef = useRef<HTMLParagraphElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    const checkTruncation = () => {
      if (textRef.current) {
        const element = textRef.current;
        const isTextTruncated = element.scrollWidth > element.clientWidth;
        setIsTruncated(isTextTruncated);
      }
    };

    checkTruncation();

    window.addEventListener("resize", checkTruncation);
    return () => window.removeEventListener("resize", checkTruncation);
  }, [children, maxW]);

  const shouldShowTooltip = tooltip && isTruncated;

  return (
    <Tooltip
      content={children}
      closeDelay={500}
      disabled={!shouldShowTooltip}
      interactive
    >
      <Text ref={textRef} truncate maxW={`${maxW}px`}>
        {children}
      </Text>
    </Tooltip>
  );
};

export default TruncateText;
